import React from "react";
import { RichTextPreview } from "cms/rich-text/simplicity-composer-tiptap/index";

const Hero = (props) => {
    
    const slides = props?.slides;
    const index = props?.index;
    const imageDatas = props?.imageDatas;
    
    // slides
    const slide = slides[index];
    const title = slide?.title;
    const subTitle = slide?.subTitle ?? "";
    const description = slide?.description;
    const link = slide?.link;
    const image_position = props?.image_position;
    
    // link
    const text = link?.text;
    const link_url = link?.url;
    
    //imageDatas
    const imageData = imageDatas[index];
    const imageUrl = imageData?.url;

    if (image_position === "left" || image_position === "right") {
        const isLeft = image_position === "left";
        const imageContainerClass = isLeft ? "hero-left-container" : "hero-right-container";
        const contentContainerClass = isLeft ? "hero-right-container" : "hero-left-container";
        const wrapperClass = isLeft ? "hero-left-wrapper" : "hero-right-wrapper";
        
        return (
            <div className={`hero-wrapper ${wrapperClass}`}>
                <div className={imageContainerClass}>
                    <img src={imageUrl} alt="" />
                </div>
                <div className={contentContainerClass}>
                    <h1 className="hero-title">{title}</h1>
                    <h1 className="hero-sub-title">{subTitle}</h1>
                    <RichTextPreview richtext={description} className="carousel-slide-description" />
                    <div className="hero-cta">
                        <a href={link_url}>{text}</a>
                    </div>
                </div>
            </div>
        );
    }

    if (!image_position || image_position === "background") {
        return (
            <div className="hero-wrapper">
                <img src={imageUrl} className="hero-background-image" alt="" />
                <div className="hero-container">
                    <h1 className="hero-title">{title}</h1>
                    <h1 className="hero-sub-title">{subTitle}</h1>
                    <RichTextPreview richtext={description} className="carousel-slide-description" />
                    <div className="hero-cta">
                        <a href={link_url}>{text}</a>
                    </div>
                </div>
            </div>
        );
    }
    
    return (
        <div className="hero-wrapper">
            <img src={imageUrl} className="hero-background-image" alt="" />
            <div className="hero-container">
                <h1 className="hero-title">{title}</h1>
                <h1 className="hero-sub-title">{subTitle}</h1>
                <RichTextPreview richtext={description} className="carousel-slide-description" />
                <div className="hero-cta">
                    <a href={link_url}>{text}</a>
                </div>
            </div>
        </div>
    );
};

export { Hero };
